export default [
	{
		path: '/app/trade',
		name: 'trade',
		component: () => import('../../../views/dashboard/customer/TradeComponent.vue'),
		meta: {
			allowedUsers: ['customer'],
		},
		redirect: {
			name: 'trade.equity'
		},
		children: [
			{
				path: 'equities',
				name: 'trade.equity',
				component: () => import('../../../views/dashboard/customer/trade/TradeEquitiesComponent.vue'),
				meta: {
					allowedUsers: ['customer'],
				},
			},
			{
				path: 'fixed-income',
				name: 'trade.fixed-income',
				component: () => import('../../../views/dashboard/customer/trade/TradeFixedIncomeComponent.vue'),
				meta: {
					allowedUsers: ['customer'],
				},
			},
			{
				path: 'history',
				name: 'trade.history',
				component: () => import('../../../views/dashboard/customer/trade/TradeHistoryComponent.vue'),
				meta: {
					allowedUsers: ['customer'],
				},
			},
		],
	},
]
